var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPersonWalkingCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#CCCFD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4242 8.95781C15.241 8.95781 15.9031 8.29568 15.9031 7.4789C15.9031 6.66213 15.241 6 14.4242 6C13.6074 6 12.9453 6.66213 12.9453 7.4789C12.9453 8.29568 13.6074 8.95781 14.4242 8.95781Z",
    fill: "#181818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0481 15.6303C9.68827 15.5776 9.43373 15.2528 9.4864 14.8842L9.73216 13.1287C9.82871 12.4529 10.171 11.8297 10.7064 11.3996L12.5058 9.94258C13.0061 9.59148 13.5766 9.48616 14.1208 9.62659C14.665 9.76703 15.1214 10.1357 15.3672 10.6448L16.1659 12.4704C16.2449 12.6548 16.3941 12.8128 16.5784 12.9005L18.448 13.8397C18.7728 14.0065 18.9044 14.4014 18.7377 14.7262C18.5709 15.051 18.1759 15.1826 17.8512 15.0159L15.9904 14.0767C15.534 13.8485 15.1653 13.4623 14.9634 12.9883L14.1822 11.1977C14.112 11.0661 13.9716 10.952 13.796 10.9081C13.6205 10.8642 13.445 10.8993 13.2957 10.9959L11.5315 12.4178C11.2594 12.6372 11.0839 12.9532 11.0312 13.3043L10.7942 15.0597C10.7415 15.4196 10.4168 15.6742 10.0481 15.6215V15.6303Z",
    fill: "#181818"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47998 14.9453L10.7901 15.1062L10.745 15.4734C10.7282 15.6105 10.6035 15.7079 10.4664 15.6911L9.65256 15.5912C9.51552 15.5743 9.41806 15.4496 9.43489 15.3126L9.47998 14.9453Z",
    fill: "#181818"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 14.9688L18.3286 13.7823L18.823 14.0234C18.9471 14.084 18.9986 14.2336 18.9381 14.3577L18.5786 15.0947C18.5181 15.2188 18.3684 15.2704 18.2443 15.2099L17.75 14.9688Z",
    fill: "#181818"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7141 20.3978L14.7562 15.7722C14.4578 15.307 14.3524 14.7364 14.4753 14.1923L15.1863 10.9798L12.7901 10.4531L12.0703 13.7446C11.9562 14.2537 12.0528 14.7891 12.3336 15.228L16.2483 21.3458C16.5116 21.7583 17.0558 21.8724 17.4596 21.6091C17.8721 21.3458 17.9862 20.8016 17.7229 20.3978H17.7141Z",
    fill: "#181818"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6185 15.7461L11.127 17.9667C11.0831 18.1511 11.0041 18.3354 10.8812 18.4846L9.19599 20.5648C8.88879 20.9423 8.95023 21.4952 9.32765 21.8024C9.70508 22.1096 10.258 22.0482 10.5653 21.6708L12.3646 19.4413C12.5753 19.178 12.7245 18.8708 12.8035 18.5373L12.9527 17.8439L11.6185 15.7549V15.7461Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonWalkingCircle);
export default __webpack_public_path__ + "static/media/icon-person-walking-circle.82cae2ae55d3d640b72c9e34d4e2ae9f.svg";
export { ForwardRef as ReactComponent };